import './style.scss';


export function footerBlock() {
  const footerSelector = document.querySelector('footer');
  if (!footerSelector) return;
  
  
}

